import { render, staticRenderFns } from "./MajorFirst.vue?vue&type=template&id=ac79c53e&scoped=true"
import script from "./MajorFirst.vue?vue&type=script&lang=js"
export * from "./MajorFirst.vue?vue&type=script&lang=js"
import style0 from "./MajorFirst.vue?vue&type=style&index=0&id=ac79c53e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac79c53e",
  null
  
)

export default component.exports